declare global {
  interface Window {
    _iub?: { cs?: { api?: { openPreferences?: () => void } } }
  }
}

export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.server || to.hash !== '#cookie-choices')
    return

  window._iub?.cs?.api?.openPreferences?.()

  return navigateTo({ path: to.path, query: to.query, hash: '' }, { replace: true })
})
